import { useUrlLocationOperations } from '@composables/useUrlLocationOperations';
import { useProduct } from '@modules/product';
import { useProductFlags } from '@modules/featureControl';
import useSelectedMemberId from '@modules/latchkey/composables/useSelectedMemberId';

export function useReviewsRedirect() {
  const { productId } = useProduct();
  const selectedMemberId = useSelectedMemberId(productId);
  const { isConsolidatedThirdVariantFlag } = useProductFlags();
  const { redirectUrl } = useUrlLocationOperations();
  /**
   * Checks starRating query and redirects to add review page
   *
   * @param {number} [rating]
  */
  const redirectToWriteReview = (rating) => {
    redirectUrl('reviews.writeAReview', {
      ID: productId,
      ...(rating && { starRating: rating }),
      ...(isConsolidatedThirdVariantFlag && selectedMemberId.value && { memberId: selectedMemberId.value }),
    });
  };

  /**
   * Scroll to the reviews section
   */
  const scrollToReviews = () => {
    const reviewsSection = document.getElementById('review-section');

    if (reviewsSection) {
      reviewsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return {
    redirectToWriteReview,
    scrollToReviews,
  };
}

export default useReviewsRedirect;
